import { SmoMoonType } from '../../Models/Smo/SmoMoonType';
import { SmoMultiMoonTextProcessingData } from './Models/SmoMultiMoonTextProcessingData';
import { SmoSingleMoonTextProcessingData } from './Models/SmoSingleMoonTextProcessingData';
import { SmoStoryMoonTextProcessingData } from './Models/SmoStoryMoonTextProcessingData';
import { TextProcessingManager } from './TextProcessingManager';

export class SmoTextProcessingManager implements TextProcessingManager<SmoMoonType> {
  public processingData = {
    [SmoMoonType.single]: new SmoSingleMoonTextProcessingData(),
    [SmoMoonType.story]: new SmoStoryMoonTextProcessingData(),
    [SmoMoonType.multi]: new SmoMultiMoonTextProcessingData()
  };
}
